import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { HeaderComponent } from '../../components/header/header.component';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'app-main-template',
  standalone: true,
  imports: [CommonModule, RouterModule, HeaderComponent],
  templateUrl: './main-template.component.html',
  styleUrls: ['./main-template.component.scss'],
})
export class MainTemplateComponent implements AfterViewInit, OnDestroy {
  isSidebarOpen = false;
  isSidebarCollapsed = false;
  currentPath = '';
  private routerSubscription?: Subscription;

  @ViewChild('sidebarMenu') sidebarMenu!: ElementRef<HTMLDivElement>;

  constructor(
    public permissionService: PermissionService,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {
    this.currentPath = this.normalizeUrl(this.router.url);
    this.routerSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.currentPath = this.normalizeUrl(event.urlAfterRedirects);
        if (window.innerWidth < 992) {
          this.isSidebarOpen = false;
        }
        this.cdr.markForCheck();
      });
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  toggleSidebar() {
    if (window.innerWidth < 992) {
      this.isSidebarOpen = !this.isSidebarOpen;
      return;
    }

    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  closeMobileSidebar(): void {
    this.isSidebarOpen = false;
  }

  openNotifications(): void {
    this.closeMobileSidebar();
    void this.router.navigate(['/notifications']);
  }

  hasPermission(permission: string): boolean {
    return this.permissionService.hasPermission(permission);
  }

  hasAnyPermission(permissions: string[]): boolean {
    return this.permissionService.hasAnyPermission(permissions);
  }

  isMenuActive(paths: string | string[], exact = false): boolean {
    const menuPaths = Array.isArray(paths) ? paths : [paths];

    return menuPaths.some((path) => {
      if (exact) {
        return this.currentPath === path;
      }

      return this.currentPath === path || this.currentPath.startsWith(`${path}/`);
    });
  }

  private normalizeUrl(url: string): string {
    const path = url.split('?')[0].split('#')[0] || '/';
    return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
  }

  onSearchMenu(searchTerm: string) {
    const term = searchTerm.toLowerCase().trim();
    const menuItems = Array.from(
      this.sidebarMenu.nativeElement.querySelectorAll('.nav-item'),
    ) as HTMLElement[];
    const sectionHeaders = Array.from(
      this.sidebarMenu.nativeElement.querySelectorAll('.sidebar-section-header'),
    ) as HTMLElement[];

    menuItems.forEach(item => {
      const text = item.textContent?.trim().toLowerCase() || '';
      item.style.display = text.includes(term) ? 'flex' : 'none';
    });

    sectionHeaders.forEach(section => {
      let nextElement = section.nextElementSibling as HTMLElement;
      let sectionHasVisibleItems = false;
      while (nextElement && !nextElement.classList.contains('sidebar-section-header')) {
        if (nextElement.classList.contains('nav-item') && nextElement.style.display !== 'none') {
          sectionHasVisibleItems = true;
          break;
        }
        nextElement = nextElement.nextElementSibling as HTMLElement;
      }
      section.style.display = sectionHasVisibleItems || term === '' ? 'block' : 'none';
    });
  }
}
